import { render, staticRenderFns } from "./BuyFromJCIPreview.vue?vue&type=template&id=6b14df37"
import script from "./BuyFromJCIPreview.vue?vue&type=script&lang=js"
export * from "./BuyFromJCIPreview.vue?vue&type=script&lang=js"
import style0 from "./BuyFromJCIPreview.vue?vue&type=style&index=0&id=6b14df37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports